<template>
  <v-container fluid>
    <v-card class="flex">
      <v-card-title v-if="user">
        User Activity for {{ user.forename }} {{ user.surname }}
      </v-card-title>
      <v-card-text>
        Joined: {{ formatPalmDateTime(user.dateJoined) }}
        <br />
        Last Logged In: {{ formatPalmDateTime(user.lastLogin) }}
        <br />
        Last Activity: {{ formatPalmDateTime(user.lastActivity) }}
      </v-card-text>
      <v-card-text>
        <v-row v-if="userActivity">
          <v-spacer />
          <v-col cols="12" md="6">
            <v-card elevation="12">
              <v-card-title>Recent Posts
              </v-card-title>

              <v-data-table :items="postActivity" class="elevation-1  table-striped" hide-default-footer
                disable-pagination must-sort calculate-widths dense>

                <template v-slot:header>
                  <tr>
                    <th class="text-left">Posted In Topic</th>
                    <th class="text-left">On</th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <b><a :href="'/post/' + item.boardId + '/' + item.topicId + '/' + item.postId">{{ item.subject
                      }}</a></b>
                    </td>
                    <td>{{ formatPalmDateTime(item.messageDate + item.messageTime) }}</td>
                  </tr>
                </template>
              </v-data-table>



            </v-card>

          </v-col>
          <v-col cols="12" md="6">
            <v-card elevation="12">
              <v-card-title>Recently Read Topics
              </v-card-title>

              <v-data-table :items="postReadActivity" class="elevation-1  table-striped" hide-default-footer
                disable-pagination must-sort calculate-widths dense>

                <template v-slot:header>
                  <tr>
                    <th class="text-left">Topic</th>
                    <th class="text-left">Read On</th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <b><a :href="'/post/' + item.boardId + '/' + item.topicId">{{ item.subject }}</a></b>
                    </td>
                    <td style="white-space:nowrap">{{ formatPalmDateTime(item.lastReadDateTime) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row v-if="userActivity">
          <v-spacer />
          <v-col cols="12" md="6">
            <v-card elevation="12">
              <v-card-title>Pages Visited
              </v-card-title>

              <v-data-table :items="userPageLastReadActivity" class="elevation-1  table-striped" hide-default-footer
                disable-pagination must-sort calculate-widths dense>

                <template v-slot:header>
                  <tr>
                    <th class="text-left">Page</th>
                    <th class="text-left">Last Visited On</th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <b>{{ item.page }}</b>
                    </td>
                    <td style="white-space:nowrap">{{ formatPalmDateTime(item.lastViewedDateTime) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card elevation="12">


              <v-card-title>Message Activity (Last 90 Days)</v-card-title>
              <v-card-text>
                {{ getMessageSentText(userMessage90DayActivity) }}
              </v-card-text>
              <v-card-text>
                {{ getMessageReceivedText(userMessage90DayActivity) }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row v-if="userActivity">
          <v-spacer />
          <v-col cols="12">


            <v-card elevation="12">
              <v-card-title>Recently Liked Posts
              </v-card-title>

              <v-data-table :items="userLikedPosts" class="elevation-1  table-striped" hide-default-footer
                disable-pagination must-sort calculate-widths dense>

                <template v-slot:header>
                  <tr>
                    <th class="text-left">Topic</th>
                    <th class="text-left">Post Text (Images Removed)</th>
                    <th class="text-left">Posted By</th>
                  </tr>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <b><a :href="'/post/' + item.boardId + '/' + item.topicId + '/' + item.postId">{{ item.topicSubject
                      }}</a></b>
                    </td>
                    <td><span v-html="getPostText(item.postMessage)" /></td>
                    <td style="white-space:nowrap">{{ item.postUserForename }} {{ item.postUserSurname }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>


          </v-col>
          <v-spacer />
        </v-row>
      </v-card-text>
    </v-card>
</v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import dateFunctions from "@/functions/dateFunctions";

export default {
  props: ["user"],
  data: () => ({
    userActivity: null,
  }),
  beforeMount() {
    this.getUserActivity();
  },
  computed: {
    postActivity() {
      return this.userActivity[0].userPostActivity;
    },
    postReadActivity() {
      return this.userActivity[0].userPostReadActivity;
    },
    userMessage90DayActivity() {
      return this.userActivity[0].userMessage90DayActivity[0];
    },
    userPageLastReadActivity() {
      return this.userActivity[0].userPageLastReadActivity;
    },
    userLikedPosts() {
      return this.userActivity[0].userLikedPosts;
    },
  },
  methods: {
    formatPalmDateTime(datetime) {
      return (!datetime) ? null : dateFunctions.formatPalmDateTimeShort(datetime.slice(0, 8), datetime.slice(8, 14));
    },
    getMessageSentText(messageData) {
      if (messageData.messageSentCount == null) {
        return "no messages have been sent by this user in the past 90 days"
      }
      return messageData.messageSentCount + " messages sent in the last 90 days. Most recent message sent on " + this.formatPalmDateTime(messageData.lastMessageSentDateTime);
    },
    getPostText(message) {
      var span = document.createElement('span');
      span.innerHTML = this.atMax3Paragraphs(message);
      return span.textContent || span.innerText;
    },
    atMax3Paragraphs(text) {
      return text.split("<br").slice(0, 6).join("<br");
    },

    getMessageReceivedText(messageData) {
      if (messageData.messageReceivedCount == null) {
        return "no messages have been received by this user in the past 90 days"
      }
      return messageData.messageReceivedCount + " messages received in the last 90 days. Most recent message sent on " + this.formatPalmDateTime(messageData.lastMessageReceivedDateTime);
    },
    async getUserActivity() {

      let userActivityRequest = serverFunctions.getUserActivityRequestObject(
        userFunctions.getLoggedInUser(),
        this.user
      );

      this.userActivity = await serverFunctions.getPostResponse(
        "/getUserActivitySummary",
        userActivityRequest
      );
    },
  },
};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>
